import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { silenceErrorAlert } from 'conversations-error-reporting/error-actions/builders/silenceErrorAlert';
import { FETCH_FORM } from '../constants/asyncActionTypes';
import { getForm } from '../clients/getForm';
export const fetchForm = createAsyncAction({
  requestFn: getForm,
  actionTypes: FETCH_FORM,
  toRecordFn: formResponse => formResponse,
  failureMetaActionCreator: silenceErrorAlert
});